import React from "react";
import styles from "./panel.module.scss";
import { PanelHeader } from "./panel-header";
import { PanelTabs } from "./panel-tabs";
import { PanelBlock } from "./panel-block";

type PanelProps ={
  fullWidth?: boolean | null;
  fullHeight?: boolean | null;
  focused?: boolean | null;
  testId?: string;
}

export const Panel = ({
  fullWidth,
  fullHeight,
  focused,
  testId,
  children,
}: React.PropsWithChildren<PanelProps>): JSX.Element => {
  let header;
  let tabs;
  const blocks: any[] = [];

  React.Children.forEach(children, (child: any) => {
    switch (child?.type) {
      case Panel.Block:
        blocks.push(child);
        break;
    }
  });

  return (
    <div
      data-testid={testId}
      className={`${styles.panel} ${fullWidth ? styles.is_fullwidth : ""} ${fullHeight ? styles.is_fullheight : ""} ${focused ? styles.is_focused : ""}`}
    >
      {header}
      {tabs}
      {blocks.map((value, index) => {
        return (
          <PanelBlock
            key={value.key === null ? index : value.key}
            visible={value.props.visible}
            active={value.props.active}
            focused={value.props.focused}
            testId={
              value.props.testId ||
              (testId === undefined ? undefined : testId + "-block")
            }
          >
            {value.props.children}
          </PanelBlock>
        );
      })}
    </div>
  );
};

Panel.Header = PanelHeader;
Panel.Tabs = PanelTabs;
Panel.Block = PanelBlock;
